import { rollingZScore } from './utils';
import { prepareMarketAIData } from './prepareMarketAIData';
import useStore from '../Store/market_greeks_data_store';

export function normalizeMarketAIData() {
  const data = prepareMarketAIData();
  const windowSize = 30;
  const windowsForUltimateGEX = [10, 20, 30, 40, 60];
  const result = [];

  // === Extract raw values ===
  const rawVVIXPressure = data.map(d => d.VVIX_pressure); // already normalized
  const rawGEXMomentum = data.map(d => d.SPX_GEX_momentum_5);
  const rawSPXGEX = data.map(d => d['SPX gex']);

  // === Normalize SPX_GEX_momentum_5 ===
  const gexMomentumZ = rollingZScore(rawGEXMomentum, windowSize);

  // === Precompute z-scores for Ultimate GEX ===
  const spxGexZScoresByWindow = {};
  for (const win of windowsForUltimateGEX) {
    spxGexZScoresByWindow[win] = rollingZScore(rawSPXGEX, win);
  }

  for (let i = 0; i < data.length; i++) {
    if (i < 60) continue;

    const row = { ...data[i] };
    row.VVIX_pressure = rawVVIXPressure[i];
    row.SPX_GEX_momentum_5 = gexMomentumZ[i]; // <-- Use normalized version

    // === Ultimate GEX ===
    const ultimateGEXSmoothed = [];

    for (const win of windowsForUltimateGEX) {
      const smooth3 = [i - 2, i - 1, i]
        .map(j => {
          if (j < 0) return null;
          const zInner = spxGexZScoresByWindow[win][j];
          const msGex = data[j]['MS Gex'];
          return typeof zInner === 'number' && typeof msGex === 'number' ? zInner + msGex : null;
        })
        .filter(v => typeof v === 'number');

      if (smooth3.length === 3) {
        const ma = smooth3.reduce((a, b) => a + b, 0) / smooth3.length;
        ultimateGEXSmoothed.push(ma);
      }
    }

    if (ultimateGEXSmoothed.length > 0) {
      const avgUltimate = ultimateGEXSmoothed.reduce((a, b) => a + b, 0) / ultimateGEXSmoothed.length;
      const prev = result[result.length - 1]?.Ultimate_GEX;
      row.Ultimate_GEX = prev != null ? (avgUltimate + prev) / 2 : avgUltimate;
    }

    result.push(row);
  }

  // === Final output fields to store ===
  const finalOutput = result.map(row => ({
    date: row.date,
    'SPX open': row['SPX open'],
    'SPX high': row['SPX high'],
    'SPX low': row['SPX low'],
    'SPX close': row['SPX close'],
    'VVIX fast': row['VVIX fast'],
    'VVIX slow': row['VVIX slow'],
    VVIX_pressure: row.VVIX_pressure,
    SPX_GEX_momentum_5: row.SPX_GEX_momentum_5,
    Ultimate_GEX: row.Ultimate_GEX,
    'SPX gex': row['SPX gex'],
    'MS Gex': row['MS Gex'], // <-- Add this line
  }));

  // console.log("✅ Last 10 rows of final normalized output:", finalOutput.slice(-10));

  // === Set in Zustand store ===
  const { setMarketAINormalizedData } = useStore.getState();
  setMarketAINormalizedData(finalOutput);

  return finalOutput;
}











